export var levelMapping = {
    3: {
        text: '优秀',
        itemColor: 'rgba(255, 153,2)',
        color: 'rgb(255, 153, 3)',
    },
    2: {
        text: '适中',
        itemColor: 'rgba(0, 217,157)',
        color: 'rgba(0, 217, 157)',
    },
    1: {
        text: '欠佳',
        itemColor: 'rgba(99, 156,255)',
        color: 'rgb(98, 156, 255)',
    },
};
